// Mock data for Medusai Graphics Unlimited

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/zanhufwq_file_00000000c1dc7230a9c2ea47b1504a2f.png",
    title: "MEDUSA - Turquoise Serpent Queen with Equipment ⭐",
    category: "Mythic"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/2red9jxz_file_00000000fe8c71f5875e2317ac1c2783.png",
    title: "MEDUSA - Green Serpent Goddess Wall Installation",
    category: "Mythic"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/6df9340r_file_00000000698871f586656bf0658aed1e.png",
    title: "Cyberpunk Cityscape - Futuristic Wall Print",
    category: "Urban"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/hw2i37rv_file_00000000b4f471f8b5d142adb3157f4d.png",
    title: "Floral Bouquet - Botanical Wall Art with Printer",
    category: "Branding"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/feghf0at_file_00000000724c71fda67094dd4002d227.png",
    title: "Before & After - Transformation Gallery Showcase",
    category: "Branding"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/2vtrig9p_OIP-1670130992.3Ya4uktMQomYsHHu0y1aAgHaHa.jpg",
    title: "Wall Printer in Action - Professional Equipment",
    category: "Branding"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/qrbo5cq0_OIP-102664141.uNJf9uoXEbfXQCIF5VXSKwHaHa.jpg",
    title: "Vertical Wall Printing Technology",
    category: "Branding"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/vpdgz1ce_OIP-4044242703.m43Dwl8VNUxRHfLm0Nt9LgHaEO.jpg",
    title: "Large Format Ocean Mural Installation",
    category: "Branding"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/xa97ah0z_OIP-3291325002.VlGH4hZC28M4Tx0kzpc8FAHaFj.jpg",
    title: "Custom Wall Art Printing Process",
    category: "Branding"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/u2qvjiyx_OIP-4075391602.p1K4a8MI3rqIAo1wXaMdswHaEW.jpg",
    title: "Commercial Mural Installation - Modern Art",
    category: "Branding"
  },
  {
    id: 32,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/eup6a7i9_highcontrast%20depicti%20%2814%29.jpg",
    title: "MEDUSA QUEEN - Signature Masterpiece ⭐",
    category: "Mythic"
  },
  {
    id: 33,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/fffmh5ye_highcontrast%20depicti%20%2812%29.jpg",
    title: "Medusa - Purple Serpent Mystique",
    category: "Mythic"
  },
  {
    id: 34,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/qbwzl8rd_file-29ukpBFWk3FpfpHhRCH3JX.webp",
    title: "Serpent Flames - Purple Fire Design",
    category: "Abstract"
  },
  {
    id: 35,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/344kvqdm_highcontrast%20depicti%20%281%29.jpg",
    title: "Medusa - High Contrast Serpent Portrait",
    category: "Mythic"
  },
  {
    id: 36,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/ykjkdvr3_highcontrast%20depicti%20%2816%29.jpg",
    title: "Gorgon Queen - Dramatic Serpent Crown",
    category: "Mythic"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/eyhljt93_file_000000009aa471f5a3336f30702a22e6.png",
    title: "Sports Team Logos - Multiple Brand Installations",
    category: "Sports"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/p6pk2mxn_c95327c0-49c1-4073-9f89-abba8577350f_image_marker.jpg",
    title: "Team Logo Wall - Professional Sports Branding",
    category: "Sports"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/k96jnvpg_8752fe20-b1f2-412c-91eb-ec17bb345335_image_marker.jpg",
    title: "Before & After - Team Logo Transformation",
    category: "Sports"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/7dshva33_0799cbc8-baed-4fbf-8609-daebdef4b652_image_marker.jpg",
    title: "Sports Branding - Wall Graphics Installation",
    category: "Sports"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/k8vb3slq_62653b73-473a-4e06-92f3-81b6c394ad81_image_marker.jpg",
    title: "Athletic Team Logo - Professional Wall Print",
    category: "Sports"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/tec9sz1t_highcontrast%20depicti%20%285%29.jpg",
    title: "Medusa - Cyberpunk Serpent Goddess",
    category: "Cyberpunk"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/dm5s3s5w_highcontrast%20depicti%20%2810%29.jpg",
    title: "Medusa - Urban Mythic Portrait",
    category: "Portrait"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/gkn6gnbt_highcontrast%20depicti%20%2818%29.jpg",
    title: "Medusa - Turquoise Serpent Vision",
    category: "Abstract"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/5f7tamgy_fda331f5-c028-4bf9-9138-96b154228955_image_marker.jpg",
    title: "Custom Wall Mural Installation",
    category: "Branding"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/m70ad3cb_c5b809e7-4ab2-4bef-bf80-781dc73b13d6_image_marker.jpg",
    title: "Professional Wall Graphics",
    category: "Branding"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/38e5l2uj_64fd2b7e-e90a-4e84-9b2e-ecb359002701_image_marker.jpg",
    title: "Large Format Wall Print",
    category: "Branding"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/yy2b6yoj_4c627777-ebb8-45c0-adbf-1851ca9fa57c_image_marker.jpg",
    title: "Wall Art Installation Project",
    category: "Branding"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/g6iv7pm8_2b4220a2-351d-43c5-9a78-b8b1336deefe_image_marker.jpg",
    title: "Commercial Wall Mural",
    category: "Branding"
  },
  {
    id: 24,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/7djaw6b7_4890db11-de98-49bf-a34a-b5190044de07_image_marker.jpg",
    title: "Professional Mural Design",
    category: "Branding"
  },
  {
    id: 25,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/tlcc6zen_OIP-1639525897.avLJvQvaP3Ibdm97bPQEUgHaHa.jpg",
    title: "Professional Wall Printer - Dragon Art",
    category: "Branding"
  },
  {
    id: 26,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/4ej9b87w_OIP-456244294.yH6n3YGhUSRkacZRr0-3EgHaHa.jpg",
    title: "Vertical Wall Printer - Butterfly Installation",
    category: "Branding"
  },
  {
    id: 27,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/8chp321i_OIP-1499009885.lPxnlsVLGGZeGfQ6PzUNGwHaHa.jpg",
    title: "Wall Printing Technology - Lion Mural",
    category: "Branding"
  },
  {
    id: 28,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/fjweaiwi_OIP-1910476721.XCswyJOpzCQUYY8FdTPhJAHaFn.jpg",
    title: "Large Format Waterfall Landscape Print",
    category: "Branding"
  },
  {
    id: 29,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/2gt3gqj1_OIP-1680308440.nlM0Fu1ntnn6uHCcDkTOPwHaEB.jpg",
    title: "Professional Mural Installation Equipment",
    category: "Branding"
  },
  {
    id: 30,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/936kja6z_file_000000006ef471fd8b6cc907a5d1177e.png",
    title: "Wall Mural Installation Project",
    category: "Branding"
  },
  {
    id: 31,
    url: "https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/cz64mvvo_file_00000000158c71fd9a6fef2535b25cd2.png",
    title: "Custom Graphics Wall Print",
    category: "Branding"
  }
];

export const services = [
  {
    id: 1,
    title: "Wall Murals",
    description: "Indoor and outdoor custom wall murals that transform any space",
    icon: "PaintBucket"
  },
  {
    id: 2,
    title: "Sports Team Logos & Branding",
    description: "Professional team logos, mascots, and athletic branding for gyms, schools, and man caves",
    icon: "Trophy"
  },
  {
    id: 3,
    title: "Floor Printing",
    description: "Durable floor graphics for commercial and residential spaces",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Before & After Transformations",
    description: "Complete wall makeovers from plain to extraordinary - see the dramatic difference",
    icon: "RefreshCw"
  },
  {
    id: 5,
    title: "Commercial Storefront Art",
    description: "Bold signage and storefront designs that attract customers",
    icon: "Store"
  },
  {
    id: 6,
    title: "Home Décor Feature Walls",
    description: "Transform your living space with custom accent walls",
    icon: "Home"
  },
  {
    id: 7,
    title: "QR-Enhanced Murals",
    description: "Interactive murals that link to info, videos, or AR experiences",
    icon: "QrCode"
  },
  {
    id: 8,
    title: "Artist Enlargement",
    description: "We scan and upscale artists' work to wall-size masterpieces",
    icon: "Maximize2"
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    step: "Step 1",
    title: "Choose Your Artwork",
    description: "Select from our gallery or bring your own design"
  },
  {
    id: 2,
    step: "Step 2",
    title: "We Scale It to Your Wall",
    description: "Our team digitally optimizes your design for the perfect fit"
  },
  {
    id: 3,
    step: "Step 3",
    title: "Our Printer Paints Directly",
    description: "Professional vertical wall printer applies ink directly to the surface"
  },
  {
    id: 4,
    step: "Step 4",
    title: "Permanent, Fade-Resistant Mural",
    description: "You get a lasting masterpiece that withstands time and elements"
  }
];

export const contactInfo = {
  phone: "806-560-3035",
  email: "medusaigraphics.art",
  location: "Amarillo, Texas",
  emailAlt: "MedusaiGraphics@Proton.me"
};
